<script setup lang="ts">
    const { fields, fieldLabels = true } = defineProps<{
        fields: Record<string, Field> | { handle: string; field: Field }[]
        fieldLabels: boolean
    }>()

    const data = defineModel()

    const normalisedFields = computed(() => {
        if (!Array.isArray(fields)) {
            return fields
        }

        const normalisedFields: Record<string, Field> = {}

        fields.forEach((field) => {
            normalisedFields[field.handle] = field.field
        })

        return normalisedFields
    })

    for (const [name, field] of Object.entries(normalisedFields.value)) {
        data.value[name] = field.default ?? ''
    }
</script>

<template>
    <template v-for="(field, name) in normalisedFields" :key="name">
        <div v-if="field.type === 'group'" class="layout-grid">
            <div
                class="md:gutter-x md:col-span-16 col-span-6 text-2xl font-normal uppercase md:text-4xl lg:text-5xl"
            >
                <h2 class="border-b pb-2 md:pb-3 lg:pb-4">
                    {{ field.display }}
                </h2>
            </div>

            <div class="md:gutter-r col-span-6 md:col-span-8 md:col-start-9">
                <InputFields
                    :fields="field.fields"
                    :field-labels="fieldLabels"
                    v-model="data"
                />
            </div>
        </div>

        <InputHidden
            v-else-if="
                field.visibility === 'hidden' || field.input_type === 'hidden'
            "
            :name="name"
            :field="field"
        />

        <InputText
            v-else-if="field.type === 'text' || field.type === 'textarea'"
            :name="name"
            :field="field"
            :showLabel="fieldLabels"
            v-model="data[name]"
        />

        <InputSelect
            v-else-if="field.type === 'select'"
            :name="name"
            :field="field"
            :showLabel="fieldLabels"
            v-model="data[name]"
        />

        <InputTermSelect
            v-else-if="field.type === 'terms'"
            :name="name"
            :field="field"
            :showLabel="fieldLabels"
            v-model="data[name]"
        />
    </template>
</template>
